import React from "react";
import { AlertCircle, Check, Save, Undo2 } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Sticky bottom save bar — shows dirty state and Save / Discard. */
export default function SaveBar({ dirty, saving, onSave, onDiscard }) {
  return (
    <div className="fixed bottom-0 left-0 right-0 sm:left-64 bg-white border-t border-brand-purple/15 shadow-[0_-4px_12px_rgba(0,0,0,0.04)] px-4 py-3 flex items-center justify-between z-40" data-testid="gs-save-bar">
      <p className="text-sm text-brand-inkMuted">
        {dirty
          ? <span className="text-[#B45309] font-heading font-semibold inline-flex items-center gap-1"><AlertCircle className="w-4 h-4" /> Unsaved changes</span>
          : <span className="text-[#2E7D32] inline-flex items-center gap-1"><Check className="w-4 h-4" /> All changes saved.</span>
        }
      </p>
      <div className="flex gap-2">
        <Button variant="outline" disabled={!dirty || saving} onClick={onDiscard} className="rounded-2xl h-11" data-testid="gs-discard">
          <Undo2 className="w-4 h-4 mr-1.5" /> Discard Changes
        </Button>
        <Button disabled={!dirty || saving} onClick={onSave} className="rounded-2xl h-11 px-6 bg-brand-purple hover:bg-brand-purpleHover text-white" data-testid="gs-save">
          <Save className="w-4 h-4 mr-1.5" /> {saving ? "Saving..." : "Save Changes"}
        </Button>
      </div>
    </div>
  );
}
